import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_LETTER_INFO_REQUEST: '',
  GET_LETTER_INFO_SUCCESS: '',
  GET_LETTER_INFO_FAILURE: '',
};

types = setStoreTypeValues(types, 'authLetter');

export default types;
